import { FaqJsonLd } from "@/components/JsonLd";

// Reusable FAQ block: renders a visible, native <details> accordion AND the
// matching FAQPage JSON-LD from the SAME array — so the structured data always
// corresponds to on-page content (Google FAQ guidelines). No JS required; the
// accordion works via native <details>/<summary>. Styles are self-scoped
// (.lv-faq-*) in globals.css.

export type Faq = { q: string; a: string };

export default function FaqSection({
  faqs,
  heading = "Frequently asked questions",
  eyebrow = "Questions",
  dark = false,
}: {
  faqs: Faq[];
  heading?: string;
  eyebrow?: string;
  dark?: boolean;
}) {
  if (!faqs?.length) return null;
  return (
    <section className={`lv-faq-sec${dark ? " lv-faq-dark" : ""}`}>
      <div className="lv-faq-inner">
        <div className="lv-faq-eyebrow">{eyebrow}</div>
        <h2 className="lv-faq-h">{heading}</h2>
        <div className="lv-faq-list">
          {faqs.map((f, i) => (
            <details key={i} className="lv-faq-item">
              <summary className="lv-faq-q">{f.q}</summary>
              <div className="lv-faq-a">{f.a}</div>
            </details>
          ))}
        </div>
      </div>
      <FaqJsonLd faqs={faqs} />
    </section>
  );
}
